import React from 'react';
import PropTypes from 'prop-types';

import { Criterium, CriteriumAccessibility } from '@hydra/common/criterium';

export const AccessibilityNavigation = ({ criterium }) => {
  const { data, type } = criterium;
  const content = <CriteriumAccessibility data={data} type={type} />;
  return <Criterium criterium={criterium}>{content}</Criterium>;
};

AccessibilityNavigation.propTypes = {
  criterium: PropTypes.shape({
    data: PropTypes.shape({
      duplicateIdActive: PropTypes.shape({
        notApplicable: PropTypes.bool,
        nodes: PropTypes.arrayOf(
          PropTypes.shape({
            id: PropTypes.string,
            snippet: PropTypes.string,
            nodeLabel: PropTypes.string,
            failingNodes: PropTypes.arrayOf(
              PropTypes.shape({
                snippet: PropTypes.string,
                nodeLabel: PropTypes.string
              })
            )
          })
        )
      }),
      accesskeys: PropTypes.shape({
        notApplicable: PropTypes.bool,
        nodes: PropTypes.arrayOf(
          PropTypes.shape({
            accesskey: PropTypes.string,
            snippet: PropTypes.string,
            nodeLabel: PropTypes.string,
            failingNodes: PropTypes.arrayOf(
              PropTypes.shape({
                snippet: PropTypes.string,
                nodeLabel: PropTypes.string
              })
            )
          })
        )
      }),
      tabindex: PropTypes.shape({
        notApplicable: PropTypes.bool,
        nodes: PropTypes.arrayOf(
          PropTypes.shape({
            snippet: PropTypes.string,
            nodeLabel: PropTypes.string
          })
        )
      }),
      headingOrder: PropTypes.shape({
        notApplicable: PropTypes.bool,
        nodes: PropTypes.arrayOf(
          PropTypes.shape({
            snippet: PropTypes.string,
            nodeLabel: PropTypes.string
          })
        )
      }),
      bypass: PropTypes.shape({
        notApplicable: PropTypes.bool,
        nodes: PropTypes.arrayOf(
          PropTypes.shape({
            snippet: PropTypes.string,
            nodeLabel: PropTypes.string
          })
        )
      })
    })
  })
};

export default React.memo(AccessibilityNavigation);
